module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1018434"
    }
  }, [_c('b', [_vm._v("SWEET AND SPICY NUTS")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1018934"
    }
  }, [_c('b', [_c('i', [_vm._v("Packaged in pretty jars or cellophane bags, these treats are a perfect hostess gift.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1019934"
    }
  }, [_c('b', [_vm._v("Prep: 15 minutes plus cooling "), _c('br'), _vm._v(" Bake: 25 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1020734"
    }
  }, [_vm._v("1 cup sugar")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1021034"
    }
  }, [_vm._v("2 teaspoons salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1021334"
    }
  }, [_vm._v("1 teaspoon ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1021634"
    }
  }, [_vm._v("1 teaspoon ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1021934"
    }
  }, [_vm._v("1 teaspoon coarsely ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1022234"
    }
  }, [_vm._v("½ teaspoon ground red pepper (cayenne)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1023234"
    }
  }, [_vm._v("1 large egg white")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1023534"
    }
  }, [_vm._v("6 cups raw unsalted nuts, such as walnuts, pecans, "), _c('br'), _vm._v(" natural almonds, and/or cashews")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1024334"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Preheat oven to 325°F. Grease two 15½\" by 10½\" jelly-roll pans.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1027034"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" In small bowl, combine sugar, salt, cumin, cinnamon, black pepper, and red pepper; stir until blended. In large bowl, with wire whisk, beat egg white until foamy. Add nuts to egg white; stir to coat evenly. Add sugar mixture; toss until nuts are thoroughly coated.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1029234"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Divide nut mixture between prepared jelly-roll pans, spreading evenly. Bake, stirring twice during baking, until golden brown and dry, 25 to 27 minutes. With slotted spoon, transfer nuts to waxed paper; spread in single layer. Cool. Store in airtight container at room temperature up to 1 month. Makes about 8 cups.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1032134"
    }
  }, [_vm._v("Each ¼ cup: About 165 calories, 4g protein, 11g carbohydrate, 12g total fat (2g saturated), 0mg cholesterol, 150mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399f624e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c19_r1.vue
// module id = 123
// module chunks = 0